import { IAppState } from '../localStore';

export const selectCorrelationId = (state: IAppState): string => state.saveProtocol.correlationId;
